import { useEffect, useState } from 'react'
import { Logo } from '../components/Logo'

export default function Login() {
  const [cfg, setCfg] = useState<{ googleConfigured: boolean; devLogin: boolean } | null>(null)
  useEffect(() => {
    fetch('/api/config')
      .then((r) => r.json())
      .then(setCfg)
      .catch(() => setCfg({ googleConfigured: true, devLogin: false }))
  }, [])
  const params = new URLSearchParams(location.search)
  const next = params.get('next') ?? (location.pathname.startsWith('/login') ? '/' : location.pathname + location.search)
  const q = `next=${encodeURIComponent(next)}`
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-6" style={{ paddingTop: 'var(--safe-t)' }}>
      <div className="w-full max-w-xs text-center">
        <Logo size={64} className="mx-auto" />
        <h1 className="pt-5 text-2xl font-semibold tracking-tight">Terrazzo</h1>
        <p className="pt-1 pb-8 text-sm text-muted">Our lists, notes and plans — together.</p>
        {cfg?.googleConfigured !== false && (
          <a href={`/auth/login?${q}`} className="flex h-12 items-center justify-center gap-3 rounded-xl bg-fg font-medium text-bg">
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
              <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
            </svg>
            Continue with Google
          </a>
        )}
        {cfg && !cfg.googleConfigured && !cfg.devLogin && <p className="text-sm text-muted">Sign-in isn’t configured yet (see README: Google OAuth client).</p>}
        {cfg?.devLogin && (
          <div className="mt-6 space-y-2 border-t border-line pt-6">
            <p className="text-xs text-muted">Local development</p>
            <div className="flex gap-2">
              <a href={`/auth/dev?as=owner&${q}`} className="flex h-10 flex-1 items-center justify-center rounded-lg border border-line-2 text-sm">
                Dev: Owner
              </a>
              <a href={`/auth/dev?as=cece&${q}`} className="flex h-10 flex-1 items-center justify-center rounded-lg border border-line-2 text-sm">
                Dev: Cece
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
